import dayjs, { Dayjs } from 'dayjs';

import dayjsUtc from 'dayjs/plugin/utc';
import dayjsTimezone from 'dayjs/plugin/timezone';

dayjs.extend(dayjsUtc);
dayjs.extend(dayjsTimezone);

export function getUtcMidnightDate(date?: dayjs.ConfigType): Date {
  return dayjs(date).tz('UTC').startOf('day').toDate();
}

export function mergeDateAndHour(date?: Date, hour?: Date): Date {
  const startDate = new Date(date?.toISOString() ?? 0);
  const startHourAux = new Date(hour?.toISOString() ?? 0);
  startDate.setHours(startHourAux.getHours(), startHourAux.getMinutes(), 0);
  return startDate;
}

export function getEndHour(startHour: Date, duration: number) {
  return dayjs(startHour).add(duration, 'minute').toDate();
}

export function isEqualDate(
  d1?: Dayjs | Date | null,
  d2?: Dayjs | Date | null
) {
  if (!d1 || !d2) return false;

  return dayjs(d1).toDate().getTime() === dayjs(d2).toDate().getTime();
}

export function isCloseToEndOfMonth(date: Date | Dayjs) {
  return dayjs(date).endOf('month').diff(date, 'day') <= 7;
}
